import { useLocale } from 'next-intl';
import { useCallback } from 'react';

import { trackingManager } from '@/lib/tracking/tracking-manager-instance';

interface FAQExpandedParams {
  questionId: string;
  questionKey: string;
  questionIndex: number;
}

interface FAQCTAParams {
  ctaText: string;
  destinationUrl: string;
  ctaLocation?: string;
}

export function useLandingFAQTracking() {
  const locale = useLocale();

  const trackFAQExpanded = useCallback(
    ({ questionId, questionKey, questionIndex }: FAQExpandedParams) => {
      trackingManager.trackEvent('LANDING_FAQ_EXPANDED', {
        questionId,
        questionKey,
        questionIndex,
        section: 'faq',
        language: locale,
      });
    },
    [locale],
  );

  const trackFAQCTAClicked = useCallback(
    ({ ctaText, destinationUrl, ctaLocation = 'faq-footer' }: FAQCTAParams) => {
      trackingManager.trackEvent('LANDING_FAQ_CTA_CLICKED', {
        ctaLocation,
        ctaText,
        section: 'faq',
        destinationUrl,
        language: locale,
      });
    },
    [locale],
  );

  return {
    trackFAQExpanded,
    trackFAQCTAClicked,
  };
}
